import React, { useEffect, useState } from 'react';
import { AppPositionElement, PositionStatus } from '@models/positions';
import { getAppPosition } from '@services/position/position-http.service';
import { useRouter } from 'next/router';
import useNotification from '@hooks/notification/useNotification';
import StateEnum from '@constants/state.enum';
import { Skeleton } from 'antd';
import PositionHeader from '@components/app-components/position/position-header/PositionHeader';
import PositionSteps from '@components/app-components/position/position-steps/PositionSteps';
import { useTranslation } from 'next-i18next';
import styles from './Position.module.scss';

const Position: React.FC = () => {
  const { i18n } = useTranslation('position');
  const [position, setPosition] = useState<AppPositionElement>();
  const [status, setStatus] = useState<PositionStatus>('closed');
  const [fetchKey, setFetchKey] = useState(0);

  const router = useRouter();
  const [generalError] = useNotification(
    StateEnum.ERROR,
    'Something went wrong',
    'Oops, something went wrong, please try again later!',
  );

  const fetchPosition = async () => {
    try {
      const positionElement: AppPositionElement = await getAppPosition(
        router.query.positionId as string,
        i18n.language,
      );
      setPosition(positionElement);
      if (positionElement.status) {
        if (positionElement.posted) {
          setStatus('published');
        } else {
          setStatus('open');
        }
      } else {
        setStatus('closed');
      }
      setFetchKey(fetchKey + 1);
    } catch (e: any) {
      generalError();
    }
  };

  useEffect(() => {
    fetchPosition();
  }, []);

  return position ? (
    <>
      <PositionHeader
        position={position}
        status={status}
        positionsPageNumber={router.query.pageNumber ? router.query.pageNumber.toString() : ''}
        setStatus={(value: PositionStatus) => setStatus(value)}
        fetchApplicants={fetchPosition}
      />
      <div className={styles.wrapSteps}>
        <PositionSteps key={fetchKey} positionId={position.id} />
      </div>
    </>
  ) : (
    <Skeleton active avatar paragraph={{ rows: 1 }} />
  );
};

export default Position;
